import React from 'react'

import * as Sentry from '@sentry/react'

import { CustomErrorBoundaryView } from '@components/ui'

interface ErrorBoundaryState {
  hasError: boolean
  error: Nullable<Error>
  eventId: Nullable<string>
}

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false, error: null, eventId: null }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  render() {
    if (this.state.hasError) {
      return <CustomErrorBoundaryView eventId={this.state.eventId} withSupportChannel />
    }

    return this.props.children
  }
}

export const DashboardErrorBoundary = Sentry.withErrorBoundary(ErrorBoundary, {
  fallback: <CustomErrorBoundaryView withSupportChannel />,
})
